import {IAStreamActionTypes} from './actionTypes';
import {getLatestReferenceReviewSnapshot} from '../Services/stage.service';
import {isSamePov} from '../utils/pov';

let referenceReviewHydrationSequence = 0;
const createReferenceReviewHydrationRequestId = () => (
    `reference-hydration:${Date.now()}:${++referenceReviewHydrationSequence}`
);

const hasAnalyticalRegister = (payload) => {
    const envelope = payload?.snapshot || payload?.snapshot_json || payload?.result || payload;
    const candidate = envelope?.snapshot
        || envelope?.snapshot_json
        || envelope?.result
        || envelope;
    return !!candidate
        && Array.isArray(candidate.requirements)
        && Array.isArray(candidate.verdicts);
};

export const hasCurrentReferenceReviewRunForScope = (
    referenceReview,
    analysisId,
    documentVersionId,
) => {
    const review = referenceReview || {};
    const context = review.context || {};
    const scopeMatches = (
        String(context.analysis_id || '') === String(analysisId || '')
        && String(context.document_version_id || '') === String(documentVersionId || '')
    );
    return scopeMatches
        && review.result_source === 'stream'
        && (
            !!review.terminal
            || ['extracting', 'verifying'].includes(review.status)
            || Object.keys(review.verdicts_by_id || {}).length > 0
        );
};

/**
 * Read-only hydration. This action deliberately has no dependency on criteria
 * selection and cannot launch an analysis/provider call.
 */
export const hydrateLatestReferenceReviewSnapshot = (
    analysisId,
    documentVersionId,
    expectedPov = null,
) => async (dispatch, getState) => {
    const hydrationRequestId = createReferenceReviewHydrationRequestId();
    const scope = {
        analysis_id: analysisId,
        document_version_id: documentVersionId,
        hydration_request_id: hydrationRequestId,
    };
    dispatch({
        type: IAStreamActionTypes.BEGIN_REFERENCE_REVIEW_HYDRATION,
        payload: scope,
    });

    try {
        const snapshot = await getLatestReferenceReviewSnapshot(analysisId, documentVersionId);
        if (
            expectedPov
            && !isSamePov(getState?.().stage?.main_document, expectedPov)
        ) {
            return null;
        }
        if (!snapshot) {
            dispatch({
                type: IAStreamActionTypes.SET_REFERENCE_REVIEW_UNAVAILABLE,
                payload: {...scope, reason: 'not_found'},
            });
            return null;
        }
        if (!hasAnalyticalRegister(snapshot)) {
            dispatch({
                type: IAStreamActionTypes.SET_REFERENCE_REVIEW_UNAVAILABLE,
                payload: {...scope, incompatible: true, reason: 'incompatible_snapshot'},
            });
            return null;
        }
        dispatch({
            type: IAStreamActionTypes.HYDRATE_REFERENCE_REVIEW_SNAPSHOT,
            payload: {...snapshot, ...scope},
        });
        return snapshot;
    } catch (_error) {
        if (
            expectedPov
            && !isSamePov(getState?.().stage?.main_document, expectedPov)
        ) {
            return null;
        }
        dispatch({
            type: IAStreamActionTypes.SET_REFERENCE_REVIEW_HYDRATION_ERROR,
            payload: {...scope, reason: 'snapshot_read_failed'},
        });
        return null;
    }
};
